export default "/acfdf2704e412c85fb550b6408622629b62bf7b2/39c069bc1b50ede44068ee575a7bad6a.png";